import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetInstallationsEcrDataReqData } from "./GetInstallationsEcrDataReqData";

const ENDPOINT = "/fitness_statistics/download";

export class DownloadInstallationsEcrDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: GetInstallationsEcrDataReqData = null;

    constructor(params: GetInstallationsEcrDataReqData, exportType: string) {
        super();
        this.params = params;
        this.responseType = "text";
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        console.log("DownloadInstallationsEcrDataCommand.execute()");
        return await this.executeCommand(this.params);
    }
}
